<div id="stock-tabs" class="nav nav-tabs">
    <li class="nav-item">
        <a href="#" id="sale-vehicle-link" class="nav-link" (click)="setActiveTab($event, 'sale-vehicle')">Vehicle</a>
    </li>
    @for (trade of tradeInComponent?.trades?.controls; track trade; let i = $index) {
        <li class="nav-item">
            <a href="#" id="sale-trade-{{i}}-link" class="nav-link" (click)="setActiveTab($event, `sale-trade-${i}`)">Trade #{{i+1}}</a>
        </li>
    }
    @if (saleVehicle && saleVehicle.inventoryId && !wholesale && !trading && !isLocked) {
        <li class="nav-item">
            <div class="dropdown">
                <a href="#" id="sale-trade-add-link" class="nav-link bg-light text-muted dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-expanded="false">
                    <span class="dripicons-plus"></span>
                </a>
                <div class="dropdown-menu dropdown-menu-right">
                    @if (!purchases || !purchases.length) {
                        <a class="dropdown-item disabled text-muted" href="#" (click)="tradeSelected($event, 0)">No past purchases</a>
                    }
                    @for (purchase of purchases; track purchase) {
                        <div class="dropdown-item clickable" (click)="tradeSelected($event, purchase.id)">
                            <p>{{purchase.year}} {{purchase.make}} {{purchase.model}}</p>
                            <p class="subtitle">{{purchase.stock}} | {{purchase.vin}}</p>
                        </div>
                    }
                    <div class="dropdown-divider"></div>
                    <div class="dropdown-item clickable" (click)="tradeNew($event)">
                        <p>Trade-In</p>
                        <p class="subtitle">new to dealership</p>
                    </div>
                </div>
            </div>
        </li>
    }
</div>

<div id="stock-tab-content" class="tab-content">
    <section class="tab-pane fade" id="sale-vehicle-tab">
        @if (saleVehicle && saleVehicle.inventoryId) {
            <div class="card">
                <div class="card-body">
                    <div class="flexed">
                        @if (saleVehicle.inventory.files && (saleVehicle.inventory.files.length > 0)) {
                            <img [src]="saleVehicle.inventory.files[0].url" [alt]="saleVehicle.inventory.vehicle.model" />
                        }

                        <section class="clickable" (click)="detailOpened($event)">
                            <h4 data-target="#modalInventory" data-toggle="modal">
                                {{saleVehicle.inventory.vehicle.modelYear}} {{saleVehicle.inventory.vehicle.make.split(' / ')[0]}} {{saleVehicle.inventory.vehicle.model}}
                            </h4>
                            <p class="small">{{ saleVehicle.inventory.stockNumber }} |
                                <span class="text-muted">{{ saleVehicle.inventory.vehicle.vinNumber }}</span>
                            </p>
                        </section>
                    </div>

                    @if (saleVehicle && saleVehicle.inventoryId > 0) {
                        <form [formGroup]="formRetailVehicle">
                            <div class="form-row">
                                <div class="input-group input-group-sm">
                                    <div class="input-group-prepend"><span class="input-group-text">#</span></div>
                                    <input class="form-control form-control-sm text-right" type="text" placeholder="0" autocomplete="off" id="mileage" formControlName="mileage" (blur)="blurred($event)" />
                                    <div class="input-group-append">
                                        <select class="custom-select form-control form-control-sm" formControlName="odometerStatus">
                                            @for (item of odometers; track item) {
                                                <option [value]="item.value">{{item.name}}</option>
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </form>
                    }


                    @if (!isLocked) {
                        <div class="actions">
                            @if (saleVehicle && saleVehicle['id']) {
                                <button class="btn btn-sm btn-link text-danger" data-toggle="modal" title="Discard" data-target="#delete-modal-stock" [disabled]="loading || isLocked">
                                    <span class="dripicons-trash"></span>
                                </button>
                            }
                        </div>
                    }
                </div>
            </div>
        }
        @else if (!loading) {
            <datalist id="vehicle-list">
                @for (item of matchedVehicles; track item.id) {
                    <option value="{{item.stock}} {{item.year}} {{item.make}} {{item.model}}">{{item.stock}} {{item.year}} {{item.make}} {{item.model}}</option>
                }
            </datalist>

            <div id="find-vehicle" class="card">
                <div class="card-body">
                    <form [formGroup]="findVehicle">
                        <div class="input-group input-group-sm">
                            <div class="input-group-append">
                                <span class="input-group-text"><span class="material-icons">directions_car</span></span>
                            </div>
                            <input autocomplete="off" type="search" class="form-control form-control-sm" id="search" autofocus="true" formControlName="inquiry" placeholder="Find an inventory item" list="vehicle-list" />
                            <div class="input-group-prepend">
                                <button class="btn btn-sm btn-primary"><span class="dripicons-plus" (click)="listOpened($event)"></span></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        }
    </section>

    <ng-container *ngTemplateOutlet="tradeInComponent?.tradeTabPaneTemplate"></ng-container>
    <trade-in [isLocked]="isLocked" [buyerId]="buyerId" [saleVehicleId]="saleVehicle && saleVehicle['inventoryId']" [isQuote]="isQuote"></trade-in>
</div>

<!-- detail modal -->
<button data-target="#modalInventory" data-toggle="modal" id="btn-view-detail" class="d-none"></button>
<div class="modal fade" id="modalInventory" data-backdrop="static" tabindex="-1" role="dialog" data-keyboard="false" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-full-width modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header m-1 p-1">
                <h4>Inventory Detail</h4>
            </div>
            <div class="modal-body bg-gray d-flex flex-wrap align-items-center justify-content-center py-0">
                <section class="col-md-12 col-sm-12 m-0 p-0">
                    <div class="row">
                        <div class="col-sm-12 pr-2">
                            <inventory-general-information [inventoryId]="saleVehicle ? saleVehicle['inventoryId'] : 0" [calledFromSale]="true"></inventory-general-information>
                        </div>
                    </div>
                </section>
            </div>
            <div class="modal-footer w-100 p-1">
                <button class="btn btn-secondary mt-2 ml-2 btn-sm" data-dismiss="modal" id="closeInventoryModal">Close</button>
            </div>
        </div>
    </div>
</div>



<!-- delete modal -->
<div class="modal fade" id="delete-modal-stock" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="uil-trash-alt text-danger display-1"></span>
                <h3 class="text-danger w-100 text-center">{{words[language][ 'delete' ] }}</h3>
                <span class="text-dark my-1 text-center">{{words[language][ 'deleteVehicle' ] }}</span>
                <button class="btn btn-danger mt-2" (click)="proceedWithDiscard()" data-dismiss="modal">
                    @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    {{words[language][ 'yes' ] }}
                </button>
                <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal"
                    id="btn-close-modal-delete-stock">No
                </button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->


<!-- warning modal not setup -->
<button type="button" class="btn btn-warning d-none" data-toggle="modal" data-target="#alertModalSetup" id="btn-alertModalSetup"></button>
<div id="alertModalSetup" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body p-4">
                <div class="text-center">
                    <span class="dripicons-warning h1 text-warning"></span>
                    <p>{{words[language]['stockNull']}}</p>
                    <p class="mt-3">{{isAdmin ?
                        words[language]['errorAdmin']:words[language]['errorNotAdmin']}}</p>
                    <button type="button" class="btn btn-warning my-2" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- innventory list modal -->
<button type="button" id="btn-choose-retail" class="d-none" data-target="#stock-inventory-list-modal" data-toggle="modal">&nbsp;</button>
<div class="modal fade" id="stock-inventory-list-modal" tabindex="-1" role="dialog"
    aria-labelledby="retailInventoryList" data-target="#modal">
    <div class="modal-dialog modal-full-width modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header m-1 p-1 text-dark">
                <h5 class="px-1 text-capitalize text-dark">Find/Add Retail Vehicle</h5>
                <button type="button" class="close" id="btn-close-modal-inventory-list" data-dismiss="modal"
                    aria-label="Close" (click)="listClosed($event)"><span>&times;</span></button>
            </div>
            <div class="modal-body">
                <inventory-list [statuses]="'available,quoted'" [show]="displayList" [allowAddVehicle]="true"
                    (vehicleSelectedEvent)="listenerChildrens($event)"></inventory-list>
            </div>
            <div class="modal-footer">
                <button class="btn btn-link" data-dismiss="modal" id="btn-close-modal-inventory-list"
                    (click)="listClosed($event)"><span class="text-muted">Cancel</span></button>
            </div>
        </div>
    </div>
</div>